import { Box, css, Stack, styled } from '@mui/material';

import ChevronDownIcon from '@/assets/icons/chevron-down-circle.svg?react';
import { ResultStructureSummary } from '@/components/result/ResultStructureSummary';
import type { RouteResultStructure } from '@/modules/api-routing';

const StyledBox = styled(Box)(
  ({ theme }) => css`
    border-radius: ${theme.spacing(1)};
    background-color: ${theme.palette.grey[100]};
    padding: ${theme.spacing(1.5)};
    cursor: pointer;

    &:hover {
      background-color: ${theme.palette.grey[200]};
    }
  `,
);

interface ResultStructureCardProps {
  resultStructure: RouteResultStructure;
  onClick: () => void;
}

export function ResultStructureCard({ resultStructure, onClick }: ResultStructureCardProps) {
  if (!resultStructure) return null;

  const algorithm =
    resultStructure?.route?.extension?.any.value.modeMetaInfo[0].tripModeAlgorithm.individualAlgorithm[0];

  return (
    <StyledBox onClick={onClick}>
      <Stack
        alignItems="center"
        direction="row"
        gap={2}
        sx={{
          backgroundColor: 'white',
          padding: 2,
          borderRadius: 1,
        }}
      >
        <Box sx={{ textAlign: 'left', minWidth: 0, flex: 1 }}>
          <ResultStructureSummary
            algorithm={algorithm}
            arrival={resultStructure?.route?.startTime}
            distance={resultStructure?.route?.distance}
            duration={resultStructure?.route?.duration}
          />
        </Box>
        <ChevronDownIcon style={{ color: 'text.primary', transform: 'rotate(-90deg)' }} />
      </Stack>
    </StyledBox>
  );
}
